import { render } from "./IngredientsList.vue?vue&type=template&id=8fc5ca4e&scoped=true"
import script from "./IngredientsList.vue?vue&type=script&lang=js"
export * from "./IngredientsList.vue?vue&type=script&lang=js"

import "./IngredientsList.vue?vue&type=style&index=0&id=8fc5ca4e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8fc5ca4e"

export default script